import { useEffect, useState } from 'react';
import { useApp } from 'App';
import AppService from 'app.service';
import { Button } from 'AppStyles';
import { OfferContainer, PackageId, Header, Icon, Fotter } from 'components/Offer/Styles';
import { FreeRibbon, FreeRibbonText, CheckIcon, DailyBonusContainer, TimerContainer, Timer } from './Styles';
import { Goods, Loader } from 'components';
import { helper } from 'utils';
import dailyBonusIcon from 'assets/offer/icons/daily_bonus.png';

const DailyBonus = ({ background, dailyBonus }) => {
  const { state, setStoreData, setDailyBonusTime, setGlobalError, openModal } = useApp();
  const { storeEvent, dailyBonusTime } = state;

  let intervalId;
  const gLt = dailyBonus?.gLt;

  const [isLoading, setIsLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState();

  const timeLeftDate = new Date(timeLeft);
  const hours = String(timeLeftDate.getUTCHours()).padStart(2, '0');
  const minutes = String(timeLeftDate.getUTCMinutes()).padStart(2, '0');
  const seconds = String(timeLeftDate.getUTCSeconds()).padStart(2, '0');

  useEffect(() => {
    if (dailyBonusTime) {
      setTimeLeft(dailyBonusTime * 1000 - Date.now() + 1000);
      intervalId = setInterval(() => {
        setTimeLeft(prevTimeLeft => {
          if (prevTimeLeft > 2000) {
            return prevTimeLeft - 1000;
          } else {
            setIsLoading(true);
            clearInterval(intervalId);
            AppService.getStoreData({ eId: storeEvent })
              .then(store => {
                setStoreData({ store });
                setDailyBonusTime(null);
                setIsLoading(false);
              })
              .catch(() => setGlobalError(true));
            return prevTimeLeft;
          }
        });
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [dailyBonusTime]);

  const handleButtonClicked = () => {
    if (isLoading) return;
    setIsLoading(true);
    AppService.claimDynamicBonus({ vae: dailyBonus.vae }).then(({ sts, dBCn }) => {
      if (sts === 's') {
        setDailyBonusTime(dBCn);
        openModal({ modal: 'dailyBonus', data: { gLt } });
      } else {
        alert('Failed to claim dynamic bonus');
      }
      setIsLoading(false);
    });
  };

  return (
    <OfferContainer>
      <FreeRibbon>
        <FreeRibbonText>Free</FreeRibbonText>
      </FreeRibbon>
      {helper.isDebugMode && <PackageId>{dailyBonus?.izid}</PackageId>}
      <Header $background={background}>
        <Icon src={dailyBonusIcon} />
        {dailyBonusTime && <CheckIcon />}
      </Header>
      <Fotter>
        {dailyBonusTime ? (
          <DailyBonusContainer>
            <TimerContainer>
              Your next daily bonus in
              <Timer>{isLoading ? <Loader size={16} width={3} /> : `${hours}:${minutes}:${seconds}`}</Timer>
            </TimerContainer>
            Come back tomorrow for a new reward
          </DailyBonusContainer>
        ) : (
          <Goods goods={gLt} withStyle />
        )}
        {!dailyBonusTime && (
          <Button onClick={handleButtonClicked}>FREE{isLoading && <Loader size={16} width={3} />}</Button>
        )}
      </Fotter>
    </OfferContainer>
  );
};

export default DailyBonus;
